export enum KlaviyoEventType {
  RETURN_TRACKING = "Return Tracking",
  RETURN_CREATED = "Return Created",
  RETURN_CREATED_ITEM = "Return Created Item",
  ORDER_TRACKING = "Order Tracking Update",
  ORDER_TRACKING_ITEM = "Order Tracking Update Item",
  PRODUCT_SAVED_TO_WISHLIST = "Product Saved to Wishlist",
  CUSTOMER_ACCOUNT_CREATED = "Customer Account Created",
  COVERAGE_INCENTIVE_CREDIT = "Coverage Incentive Credit",
}

type CustomerAccountsKlaviyoEventType =
  | KlaviyoEventType.PRODUCT_SAVED_TO_WISHLIST
  | KlaviyoEventType.CUSTOMER_ACCOUNT_CREATED;

export const isCustomerAccountsKlaviyoEventType = (
  eventType: KlaviyoEventType,
): eventType is CustomerAccountsKlaviyoEventType => {
  return (
    eventType === KlaviyoEventType.PRODUCT_SAVED_TO_WISHLIST ||
    eventType === KlaviyoEventType.CUSTOMER_ACCOUNT_CREATED
  );
};
